import isEqual from "lodash/isEqual";

export const calculateSalePrice = (item_price, sale_amount, sale_type) => {
	if (sale_type === "dollar") {
		item_price = item_price - sale_amount;
	} else if (sale_type === "percentage") {
		item_price = item_price - sale_amount / 100 * item_price;
	}

	// Ensure sale price is not negative
	if (item_price < 0) item_price = 0;

	return item_price;
};

export const getFirstVariants = product => {
	let variants_selected = [];

	// Assuming there are variants to be selected
	if (!!product.variants) {
		// Get the first set of variants
		variants_selected = product.variants.map((variantCollection, i) => {
			return variantCollection.items[0];
		});

		// Get the just the ids from the variant objects
		let ids = [];
		variants_selected.forEach(variantObj => {
			ids.push(variantObj.id);
		});

		// Get the first actual variant item that has this set as sku_ids
		for (let propertyId in product.variant_skus) {
			const skuCollection = product.variant_skus[propertyId];

			// Check if the first variant ids match the ids for the variant item
			// If so, we have the variant item we need!
			if (isEqual(ids, skuCollection.ids)) {
				variants_selected = skuCollection;
				break;
			}
		}
	}

	return variants_selected;
};



// WEBPACK FOOTER //
// ./src/utils/salePrices.js